<template>
  <span
    class="product-details-quantity-form-row__notify-block js-notify-block"
    :class="{ 'product-details-quantity-form-row__notify-block--monitored': isFavorite }"
    data-color="Transfer"
    :data-product-id="productSlug"
    :data-business-line-id="transfersBusinessLineId"
  >
    <button
      class="product-details-quantity-form-row__monitored-for-restock js-product-details-notify-on-restock-unsubscribe"
      type="button"
    >
      Monitored For Restock
    </button>
    <button
      class="product-details-quantity-form-row__monitored-for-restock-mobile js-product-details-notify-on-restock-unsubscribe"
      type="button"
    >
      Notify on Restock
    </button>
    <button
      class="product-details-quantity-form-row__notify-on-restock js-product-details-notify-on-restock-modal-open"
      type="button"
    >
      Notify on Restock
    </button>
  </span>
</template>

<script>
import { mapState } from "pinia";
import { useDtfStore } from "./store";

export default {
  name: "NotifyOnRestock",
  computed: {
    ...mapState(useDtfStore, ["isFavorite", "productSlug"]),
    transfersBusinessLineId() {
      // For DTF products, we always use Transfers business line
      // This value should match the actual Transfers business line ID
      return window.BUSINESS_LINES?.TRANSFERS || null;
    }
  }
};
</script>

<style scoped lang="scss">
.product-details-quantity-form-row__notify-block {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
</style>
